import { useRouter } from "./router";
import { UserLanguageContextProvider } from './contexts/userLanguageContextProvider';
import { ErrorHandlerContextProvider } from './contexts/ErrorHandlerContextProvider';
import { PropertyDetailsContextProvider } from './contexts/PropertyDetailsContextProvider';
import { EmbedGuard } from './components/organism/EmbedGuard';

export const App = () => {
  const { currentRoute } = useRouter();

  if (!currentRoute) {
    return (
      <main>
        <div>404 - Page not found</div>
      </main>
    );
  }

  const PageComponent = currentRoute.component;

  return (
    <UserLanguageContextProvider>
      <ErrorHandlerContextProvider>
        <PropertyDetailsContextProvider>
          <EmbedGuard>
            <main>
              <PageComponent />
            </main>
          </EmbedGuard>
        </PropertyDetailsContextProvider>
      </ErrorHandlerContextProvider>
    </UserLanguageContextProvider>
  );
};
